"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.ComponentMapper = void 0;
var _componentEngine = _interopRequireDefault(require("./component-engine"));
exports.ComponentMapper = _componentEngine["default"];